import React from 'react';

import { CircleRescue } from '@/assets/icons/circle-rescue';
import LossSbkIcon from '@/assets/icons/lossSbk';
import VoidIcon from '@/assets/icons/voidedIcon';
import WonIcon from '@/assets/icons/won';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Result } from '@/feature/bets-sbk/hooks/types';

import { betSelectionItemStyle } from './Styles';

type BetSelectionIconProps = {
    result: Result;
    variant: 's' | 'l';
    isRevived: boolean;
};

export const BetSelectionIcon = ({ result, variant, isRevived }: BetSelectionIconProps) => {
    const iconStyles = betSelectionItemStyle[variant].iconStyles;

    if (isRevived) {
        return <CircleRescue width={iconStyles.width} height={iconStyles.height} />;
    }

    switch (result) {
        case 'WON':
            return <WonIcon width={iconStyles.width} height={iconStyles.height} />;
        case 'LOST':
            return <LossSbkIcon width={iconStyles.width} height={iconStyles.height} />;
        case 'CANCELLED':
        case 'PUSHED':
        case 'MANUALLY_CANCELLED':
        case 'CASHEDOUT':
            return <VoidIcon width={iconStyles.width} height={iconStyles.height} />;
        default:
            return (
                <Box
                    borderRadius="r96"
                    width={iconStyles.width}
                    height={iconStyles.height}
                    borderWidth={2}
                    borderColor={ds.colorToken.border.strong}
                    backgroundColor={ds.colorToken.background.neutral.base}
                />
            );
    }
};
